import React from 'react';
import { getLocationsPaginated } from '../../api/locationApi';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchBar from '../SearchBar';
import { updateRedirect } from './../../helpers/redirect';
import { getPermission } from '../../api/userapi';
import '../css/View.css';

import DataTableBase from '../utils/DataTable';

class LocationView extends React.Component {
    constructor(props) {
        super(props);
        this.permission = getPermission()
        let filterValue = '';
        if (this.props.route.location.state) {
            filterValue = this.props.route.location.state.locationFilter;
            if (this.props.route.location.state.from == 'branches') {
                this.props.route.history.push('/secure/branches');
                this.props.route.history.push(this.props.route.match.url);
            }
        }
        this.state = {
            data: [],
            locations: [],
            expanded: {},
            location: {},
            value: filterValue,
            edit: false,
            create: false,
            searches: false,
            branchFilter: {},
            loading: true,
            totalRows: 0,
            perPage: 10,
            orderBy: '',
            descending: false,
            defaultPage: 1
        }
        this.isSorting = false;
        this.filterSearch = this.filterSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
        this.fetchData('', 0)
    }

    handleEdit(location) {
        this.setState({
            edit: true,
            location: location
        })
    }

    handleCreate() {
        this.setState({
            create: true
        })
    }

    handleRedirectBranch(branch) {
        let branchFilter = { branchId: branch.branchId }
        this.setState({
            branchFilter: branchFilter,
            redirectBranch: true
        })
    }


    filterSearch(event) {
        var value = event.target.value;
        if (event.key === 'Enter' && value) {
            this.fetchData(value, 0);
            this.setState({
                loading: true,
                value: value
            })
        } else if (!value) {
            this.fetchData(value, 0);
            this.setState({
                loading: true,
                value: value
            })
        }
    }

    fetchData(filterValue, page) {
        var p = <p className="cursor closed" >
            <FontAwesomeIcon icon="bars" size="sm" color="#28A745" />
        </p>;
        if (typeof filterValue === 'object')
            filterValue = this.state.value;
        if (page === undefined) {
            page = this.state.defaultPage;
        }
        if (page !== 0)
            page = page - 1;
        this.setState({ loading: true, error: false });
        var orderBy = this.state.orderBy;
        var descending = this.state.descending;
        getLocationsPaginated(filterValue, page, this.state.perPage, orderBy, descending)
            .then((res) => {
                var moreOptions = [];
                for (let x = 0; x < res.data.data.results.length; x++) {
                    moreOptions.push(p)
                }
                this.setState({
                    data: res.data.data.results,
                    pages: res.data.data.pageCount,
                    totalRows: res.data.data.rowCount,
                    moreOptions: moreOptions,
                    loading: false
                })
            }).catch((err) => {
                var errorList = [];
                err.response.data.errors.map(function (e) { errorList.push(e.message) });

                this.setState({
                    data: [],
                    error: true,
                    loading: false,
                    errorMessage: errorList
                })
            });
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage }, () => {
            this.fetchData(this.state.value, page);
        });
    }

    handlePageChange(page) {
        if (this.isSorting) return;
        this.fetchData(this.state.value, page);
    }

    handleSort(column) {
        this.isSorting = true;
        this.setState({ descending: !this.state.descending, orderBy: column.sortField }, () => {
            this.fetchData(this.state.value);
            this.isSorting = false;
        });
    }

    getData(data, _this) {
        _this.setState({
            locations: data.data.data,
            loading: false,
        });
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    closeModal() {
        this.setState({ error: false });
        this.submitted = false;
    }

    render() {

        if (this.state.edit) {
            return <Redirect
                to={{
                    pathname: `/secure/locationEdit/${this.state.location.branchId}/${this.state.location.locationId}`,
                    state: { location: this.state.location }
                }}
            />;
        }

        if (this.state.create) {
            return <Redirect
                to={{
                    pathname: `/secure/locationCreate`,
                }}
            />;
        }

        if (this.state.redirectBranch) {
            this.props.currentNavigationConnect({
                isOpen: false,
                selected: "branches",
                selectedAdmin: "",
                toggleAdminDropdown: false
            });
            return <Redirect
                to={{
                    pathname: `/secure/branchEdit/${this.state.branchFilter.branchId}`,
                    state: { branchFilter: this.state.branchFilter, from: 'locations' }
                }}
            />;
        }

        const columns = [
            {
                name:
                    <div
                        style={{
                            textIndent: 10,
                            textAlign: "left",
                            width: 360,
                        }}
                    >
                        City <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '360px',
                selector: row => row.city,
                sortable: true,
                sortField: 'city',
                cell: row => <div onClick={() => this.handleEdit(row)}><p style={{ marginLeft: "10px", }} className="cursor">{row.city}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 180,
                        }}
                    >
                        State <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '180px',
                selector: row => row.stateProvinceState,
                sortable: true,
                sortField: 'stateProvinceState',
                cell: row => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.stateProvinceState}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 460
                        }}
                    >
                        Branch <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                selector: row => row.branchName,
                sortable: true,
                sortField: 'branchName',
                cell: row => <div onClick={() => this.handleRedirectBranch(row)}><p className="cursor">{row.branchName}</p></div>
            },
        ];

        return (
            <div >

                <SearchBar
                    onKeyUp={this.filterSearch}
                    onClick={this.filterSearch}
                    onChange={this.filterSearch}
                    value={this.state.value}
                />
                <DataTableBase
                    columns={columns}
                    isLoading={this.state.loading}
                    data={this.state.data}
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.perPage}
                    paginationDefaultPage={this.state.defaultPage}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    onSort={this.handleSort}
                />
                {this.permission.isAdmin &&
                    <button onClick={() => this.handleCreate()} className="btn mt-4"> + CITY</button>}

            </div>
        );
    }
}

export default connect(
    state => {
        return {
            locations: state.data.locations
        }
    },
    dispatch => ({
        // getLocations: (callback, context, filter) => { dispatch(getLocations(callback, context, filter)) },
        currentNavigationConnect: (response) => { dispatch(updateRedirect(response)) }
    })
)(LocationView);
